import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../modules/infra/i18n';

const SelectAllBarbersOption = ({ updateBarbersViewed, checked }) => (
  <div className="c-filter-dropdown-checkbox">
    <input
      className="c-filter-dropdown-checkbox__input"
      type="checkbox"
      checked={checked}
      id="select-all-barbers-option"
      onChange={e => updateBarbersViewed(e.target.checked)}
      value="true"
    />

    <label className="c-filter-dropdown-checkbox__label" htmlFor="select-all-barbers-option">
      <span className="c-filter-dropdown-checkbox__trigger" />
      <span className="c-filter-dropdown-checkbox__text" data-automation-id="filter:barbers:selectDeselectAll">
        {t('common:filters.select_deselect_all')}
      </span>
    </label>
  </div>
);

SelectAllBarbersOption.propTypes = {
  updateBarbersViewed: PropTypes.func.isRequired,
  checked: PropTypes.bool,
};

export default SelectAllBarbersOption;
